import React from 'react';

const QrCodePlaceholder = () => {
  return <div className="Shadow" />;
};

export default QrCodePlaceholder;
